import type { Locale } from 'antd/es/locale';
import enUS from 'antd/locale/en_US';
import huHU from 'antd/locale/hu_HU';
import roRO from 'antd/locale/ro_RO';

const antdLocales: Record<string, Locale> = { en: enUS, hu: huHU, ro: roRO };

/** The antd locale for an i18next language code (`ro`, `hu`, `en-GB`, ...), English when unknown. */
export const getAntdLocale = (language: string | undefined): Locale =>
    antdLocales[(language ?? 'en').slice(0, 2)] ?? enUS;
